import ExcelJS from 'exceljs'
import fileDownload from 'js-file-download'
import moment from 'moment'

export const ExportExcel = async (records, monthFilter, departmentFilter) => {
  try {
    const workbook = new ExcelJS.Workbook()

    // Group records by month and department, applying flexible filters
    const groupedData = records.reduce((acc, item) => {
      // Chỉ lấy bản ghi có proposal_status là APPROVAL
      if (item.proposal_status !== 'APPROVAL') {
        return acc
      }

      // Check if the item has proposal times
      if (!item.proposalTimeList || item.proposalTimeList.length === 0) {
        return acc
      }

      // Extract month from the first proposal time
      const month = moment(item.proposalTimeList[0].date).format('MM-YYYY')

      // Split departments by comma and trim whitespace
      const departments = (item.create_user.department || '')
        .split(',')
        .map(dep => dep.trim())
        .filter(dep => dep)

      // Apply flexible filters and group by each department
      departments.forEach(department => {
        if (
          (!monthFilter || month === monthFilter) &&
          (!departmentFilter || department === departmentFilter)
        ) {
          if (!acc[month]) acc[month] = {}
          if (!acc[month][department]) acc[month][department] = []

          // Push the item to the department group, ensuring department in output is single value
          acc[month][department].push({
            ...item,
            create_user: {
              ...item.create_user,
              department, // Use single department for display
            },
          })
        }
      })

      return acc
    }, {})

    // Create a worksheet
    const worksheet = workbook.addWorksheet('Nghỉ Phép')

    // Set column widths
    worksheet.getColumn('A').width = 10 // STT
    worksheet.getColumn('B').width = 30 // Họ và tên
    worksheet.getColumn('C').width = 20 // Phòng ban
    worksheet.getColumn('D').width = 20 // Chức vụ
    worksheet.getColumn('E').width = 20 // Thời gian bắt đầu
    worksheet.getColumn('F').width = 20 // Thời gian kết thúc
    worksheet.getColumn('G').width = 20 // Người duyệt
    worksheet.getColumn('H').width = 30 // Ghi chú

    let rowIndex = 1

    // Check if there's any data to export
    const monthKeys = Object.keys(groupedData)

    if (monthKeys.length === 0) {
      console.warn('No data found matching the filters')
      worksheet.getCell('A1').value = 'Không có dữ liệu phù hợp'
    } else {
      // Iterate over each sorted month and department combination
      monthKeys.sort().forEach(month => {
        Object.keys(groupedData[month])
          .sort() // Sort departments for better readability
          .forEach(department => {
            // Add section title (month and department)
            worksheet.mergeCells(`A${rowIndex}:H${rowIndex}`)
            worksheet.getCell(
              `A${rowIndex}`
            ).value = `Danh sách nghỉ phép tháng: ${month} phòng: ${department}`
            worksheet.getCell(`A${rowIndex}`).alignment = {
              vertical: 'middle',
              horizontal: 'center',
            }
            worksheet.getCell(`A${rowIndex}`).font = {
              size: 14,
              bold: true,
            }

            rowIndex++

            // Add headers
            const headers = [
              'STT',
              'Họ và tên',
              'Phòng ban',
              'Chức vụ',
              'Thời gian bắt đầu',
              'Thời gian kết thúc',
              'Người duyệt',
              'Ghi chú',
            ]
            worksheet.addRow(headers)

            // Format header row
            const headerRow = worksheet.getRow(rowIndex)
            headerRow.font = { bold: true }
            headerRow.eachCell(cell => {
              cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
              }
            })

            rowIndex++

            // Populate employee data
            groupedData[month][department].forEach((item, index) => {
              const proposalTimes = item.proposalTimeList
              const startDate = moment
                .min(proposalTimes.map(time => moment(time.date)))
                .format('DD/MM/YYYY')
              const endDate = moment
                .max(proposalTimes.map(time => moment(time.date)))
                .format('DD/MM/YYYY')

              const row = worksheet.addRow([
                index + 1, // STT
                item.create_user.name_uppercase, // Họ và tên
                item.create_user.department, // Phòng ban (single department)
                item.create_user.position, // Chức vụ
                startDate, // Thời gian bắt đầu
                endDate, // Thời gian kết thúc
                item.approval_people, // Người duyệt
                proposalTimes.length === 1 ? proposalTimes[0].note || '' : '', // Ghi chú
              ])

              // Add borders to each cell in the row
              row.eachCell(cell => {
                cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' },
                }
              })

              rowIndex++
            })

            // Add an empty row after each department's data for spacing
            rowIndex++
          })
      })
    }

    // Save and download the Excel file
    const filename = `Danh_sach_nghi_phep_${new Date().getTime()}.xlsx`
    const buffer = await workbook.xlsx.writeBuffer()
    fileDownload(buffer, filename)
  } catch (error) {
    console.error('Error exporting to Excel', error)
  }
}
